/* AIJ shared behaviour — Pashupati Jewellers
   Tabs, scroll rows (arrows / mouse drag / progress), reveal-on-scroll,
   live cart count. Every init is idempotent so theme-editor reloads are safe. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- tabs ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-aij-tabs]').forEach(function (wrap) {
      if (wrap.dataset.aijInit) return;
      wrap.dataset.aijInit = '1';
      var tabs = wrap.querySelectorAll('[role="tab"]');
      var scope = wrap.closest('[data-aij-tabscope]') || document;
      var more = scope.querySelector('[data-aij-more]');
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = scope.querySelector('#' + t.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          if (on) { panel.classList.remove('is-in'); void panel.offsetWidth; panel.classList.add('is-in'); }
        });
        if (more && tab.dataset.url) more.setAttribute('href', tab.dataset.url);
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* ---------- scroll rows ---------- */
  function initRows(root) {
    root.querySelectorAll('[data-aij-row]').forEach(function (row) {
      if (row.dataset.aijInit) return;
      row.dataset.aijInit = '1';
      var box = row.closest('[data-aij-rowbox]') || row.parentElement;
      var arrows = box.querySelector('.aij-arrows');
      var prev = box.querySelector('[data-aij-prev]');
      var next = box.querySelector('[data-aij-next]');
      var bar = box.querySelector('.aij-progress span');

      function step() {
        var item = row.firstElementChild;
        if (!item) return row.clientWidth;
        var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
        var per = Math.max(1, Math.round((row.clientWidth + gap) / (item.offsetWidth + gap)));
        return (item.offsetWidth + gap) * Math.max(1, per - (per > 2 ? 1 : 0));
      }
      function update() {
        var max = row.scrollWidth - row.clientWidth;
        var scrollable = max > 4;
        if (arrows) arrows.hidden = !scrollable;
        if (prev) prev.disabled = row.scrollLeft <= 4;
        if (next) next.disabled = row.scrollLeft >= max - 4;
        if (bar && scrollable) {
          var vis = row.clientWidth / row.scrollWidth;
          bar.style.width = (vis * 100) + '%';
          bar.style.transform = 'translateX(' + ((row.scrollLeft / max) * ((1 - vis) / vis) * 100) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      row.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(row); else window.addEventListener('resize', update);
      update();

      /* mouse drag (desktop only; touch scrolls natively) */
      var down = false, moved = false, sx = 0, sl = 0;
      row.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; sx = e.clientX; sl = row.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 6) { moved = true; row.classList.add('is-dragging'); }
        if (moved) row.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (moved) {
          row.classList.remove('is-dragging');
          /* swallow the click that follows a drag so cards don't open */
          row.addEventListener('click', function swallow(ev) { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
          setTimeout(function () { moved = false; }, 0);
        }
      });
    });
  }

  /* ---------- reveal ---------- */
  var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function initReveal(root) {
    root.querySelectorAll('.aij-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- live cart count ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-aij-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !(n > 0);
    });
  }
  function refreshCount() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }
  function bindCart() {
    if (window.__aijCartBound) return;
    window.__aijCartBound = true;
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.cartData && typeof ev.cartData.item_count === 'number') setCount(ev.cartData.item_count);
        else refreshCount();
      });
    }
    /* never wrap window.fetch here: Fastrr / Shiprocket checkout scripts share it.
       Re-check on back-navigation and when the tab regains focus instead. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCount(); });
  }

  function init(root) {
    root = root || document;
    initTabs(root); initRows(root); initReveal(root);
  }

  window.AIJ = { init: init, refreshCount: refreshCount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); bindCart(); });
  else { init(); bindCart(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
